import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Injectable({
  providedIn: 'root'
})
export class GameHistoryHealthReportService {
  private intervalSelectedSubject = new BehaviorSubject<Interval[]>([]);
  private localizationMessages = new Map<string, string>();

  intervalSelected$ = this.intervalSelectedSubject.asObservable();

  constructor(private cvLocalizationService: CVLocalizationService) {
    this.cvLocalizationService.GetSection("Game_Health_Report").then((result) => {
      this.localizationMessages = result;
    });
  }

  updateIntervalSelected(intervalSelected: Interval[]) {
    this.intervalSelectedSubject.next(intervalSelected);
  }

  getLocalizationMessage(key: string, defaultValue: string = ''): string {
    if (!this.localizationMessages || !this.localizationMessages.get || !this.localizationMessages.has(key)) return defaultValue;
    return this.localizationMessages.get(key) || defaultValue;
}
}

export interface MetricSelected {
  metricID: number
  abbrev: string
  name: string
  prefix: string
  suffix: string
  conversionType: string
  direction: string
}
export interface Interval {
  StartDate: string
  EndDate: string
  Version: any
  DisplayStringDate: string
  isSelected: boolean
}

export interface GameParticipants {
  participant: Participant;
}
export interface Participant {
  RuleID: number
  CompanyID: number
  LoginID: number
  PeriodStartDate: string
  DateJoined: string
  AlreadyJoined: boolean
  TeamID: number
  Team: string
  RelatedGroupID: number
  RelatedGroupLevel: number
  RelatedGroupType: number
  LoginName: string
}

